import React from 'react';
import Footer from './Footer';
import Header from './Header';
import PropTypes from 'prop-types';
import {Box, GlobalStyles, styled} from '@mui/material';
import {useLocation, useNavigate} from 'react-router-dom';
import {logout} from './ApplicationSlice';
import {useDispatch} from 'react-redux';
import GlobalSnackbar from '../shared-components/GlobalSnackbar';
import useUser from '../utility/hooks/useUser';
import FelicityPanel from '../components/Felicity/FelicityPanel';

// AD-2653: while Felicity's side panel is open the page narrows by its width, so she never covers it.
// On a narrow screen she covers the page instead.
const AppLayoutContainer = styled(Box)(({theme}) => ({
    display: 'flex',
    minHeight: '100vh',
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
        marginRight: 'var(--felicity-panel-width, 0px)',
        transition: 'margin-right 150ms ease'
    }
}));

const MainContainer = styled('main')(({theme, isEmbedded}) => ({
    minHeight: '100%',
    flexGrow: 1,
    // AD-2653: while Felicity's side panel is open, a wide table scrolls sideways instead of running under her.
    '.felicity-open &': {minWidth: 0, overflowX: 'auto'},
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: isEmbedded ? '#ffffff' : '#F0F4F8',
}));

// AD-2653: while Felicity's side panel is open, a window opens in the space left of her, so she never covers it.
const WINDOWS_BESIDE_FELICITY = {
    '@media (min-width: 900px)': {
        '.felicity-open .MuiDialog-container': {
            paddingRight: 'var(--felicity-panel-width, 0px)',
            boxSizing: 'border-box'
        }
    }
};

const AppLayout = ({children}) => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {user, account} = useUser();
    const isEmbedded = searchParams.get('embedded') === 'true';
    const isHelpCentre = location.pathname.startsWith('/help-centre');

    const handleLogout = () => {
        dispatch(logout())
            .then(_ => {
                navigate('/login');
            });
    };

    return (
        <AppLayoutContainer>
            <GlobalStyles styles={WINDOWS_BESIDE_FELICITY}/>
            {!isEmbedded && <Header
                account={account}
                displayActions={user?.id !== undefined && account.isAuthenticated}
                handleLogout={handleLogout}
                felicity={account.isAuthenticated && !isHelpCentre ? <FelicityPanel inTopBar/> : null}/>}
            <MainContainer isEmbedded={isEmbedded}>
                {children}
            </MainContainer>
            {!isEmbedded && <Footer/>}
            <GlobalSnackbar/>
        </AppLayoutContainer>
    );
};

AppLayout.propTypes = {
    children: PropTypes.object.isRequired,
};

export default AppLayout;